<template>
    <div class="section b-4">
        <div class="row" v-if="latest_inventories.length">
            <div class="card col s12">
                <h5>Últimos inventarios</h5>
                <ul class="collection">
                    <li v-for="invent in latest_inventories" :key="invent" class="collection-item">
                        <router-link :to="{ name: 'Inventario', query: { id: invent.id } }"
                            class="grey-text text-darken-3">
                            <span>
                                Creado el {{ invent.data.created_at.toDate().toLocaleString() }} por
                                {{invent.data.userName}}
                            </span>

                            <i class="mdi mdi-open-in-new"></i>
                        </router-link>
                    </li>
                </ul>
            </div>
        </div>
        <div class="row" v-if="loading">
            <div class="col s12">
                <div class="lds-ripple">
                    <div></div>
                    <div></div>
                </div>
            </div>
            <div class="col s12">
                <span>Cargando... {{LoadingStatus}} <b>{{LoadingPercent}}</b></span>
            </div>
        </div>
        <!-- <div class="row">
            <div class="col s12" v-show="TotalOfJobs">
                <h5>Trabajos escaneados <small>{{ TotalOfJobs }} trabajo(s) en {{
                    Object.keys(cartons).length }} carton(es)</small></h5>
                <ul class="collapsible">
                    <li v-for="(job, key) in Jobs" :key="key">
                        <div class="collapsible-header">
                            <i class="mdi mdi-table-arrow-up"></i>
                            Trabajo: {{ key }}
                        </div>
                        <div class="collapsible-body">
                            <ul class="collection">
                                <li v-for="carton in job" :key="carton.no_carton" class="collection-item">
                                    <span>
                                        {{ carton.dsforderid }}-{{ carton.ccmasterid }}-{{
                                            carton.jobpart
                                        }}-{{ carton.shipviaid }}-{{ carton.no_carton }}-{{
                                            carton.total_cartons
                                        }}
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </li>
                </ul>
            </div>
           
            
        </div> -->


        <div class="row">
            <div class="col s12">
                <p class="flow-text">
                    Comienza por escanear tus paquetes en el almacén seleccionado.
                    Después presiona el botón "Realizar inventario" para generar y guardar el inventario.
                </p>
            </div>
            <!-- <div class="col s12 input-field">
                <label for="periodo-de-inventario" class="active">Periodo de inventario</label>
                <select v-model="inventario.periodo" class="browser-default" name="periodo-de-inventario" id="periodo-de-inventario">
                    <option value="7">7 días atrás</option>
                    <option value="15">15 días atrás</option>
                    <option value="30" selected>30 días atrás</option>
                    <option value="60">60 días atrás</option>
                </select>
            </div> -->
            <div class="col s12">
                <button :disabled="Object.keys(cartons).length<1" class="waves-effect waves-light btn primary-btn right blue"
                    @click="inventory()">Realizar inventario</button>
            </div>
            
        </div>
    </div>

</template>

<script>
    import M from "materialize-css";
    import firebase from "firebase/app";
    import "firebase/storage";
    // import Helpers from "../../../../../helpers";


    export default {
        name: "inventario",
        mounted() {
            this.getLatestInventories();
        },
        data() {
            return {
                
                error: false,
                loading: false,
                loading_status: "",
                loading_steep: 0,
                total_steeps: 4,
                latest_inventories: [],
                cartons_en_almacen: {},
                cartons_scanned_db: {},
                payments: null,
                inventario: {periodo: "30"},
            };
        },
        props: {
            db: Object,
            shipvia: Object,
            shipvias: Array,
            almacen: Object,
            cartons: Object
        },
        setup() {
            M.Collapsible.init(document.querySelectorAll(".collapsible"));

        },
        methods: {
            saveInventoryToFirestore(){
                console.log("Inventariado", this.inventario);
                // Save to firestore collection "inventarios"
                let doc = {
                    shipvia: this.shipvia,
                    almacen: this.almacen,
                    userId: window.user.uid,
                    userName: window.user.displayName,
                    userEmail: window.user.email,
                    created_at: new Date(),
                }
                this.loading_status = "Guardando inventario..."
                this.$forceUpdate();
                this.db.collection("inventarios").add(doc).then((docSnapshot) => {
                    console.log("Document written with ID: ", docSnapshot.id);
                    // Save inventario to localStorage
                    localStorage.setItem(`inventario-${docSnapshot.id}`, JSON.stringify(doc));
                    // Navigate to the route /inventario with props
                    let jobs_n_cartons = {}
                    Object.keys(this.cartons_scanned_db).forEach((cartonId) => {
                        let carton = this.cartons_scanned_db[cartonId]
                        if (jobs_n_cartons[carton.ccmasterid]) {
                            jobs_n_cartons[carton.ccmasterid]['cartons'][cartonId] = carton
                        } else {
                            jobs_n_cartons[carton.ccmasterid] = { cartons:{[cartonId]: carton }}
                        }
                    })

                    this.putOnStorage(docSnapshot.id, {jobs:jobs_n_cartons, ...doc}).then((url) => {
                        console.log("Uploaded a blob or file!", url);
                        docSnapshot.update({ url: url, updated_at: new Date() }).then(() => {
                            this.loading = false;
                            this.loading_steep++;
                            this.$router.push({ name: "Inventario", query: { id: docSnapshot.id } }, { replace: true });
                        }).catch((error) => {
                            console.error("Error adding document: ", error);
                            M.toast({ html: "<i class='mdi mdi-alert-circle'></i>&nbsp;Error al guardar el inventario", classes: "red" });
                            this.error = error
                        }).finally(() => {
                            this.loading = false;
                            this.loading_steep++;
                            M.toast({ html: "<i class='mdi mdi-check-circle'></i>&nbsp;Inventariado", classes: "green" });
                        });
                    });
                    
                })
            },
            putOnStorage(id, inventario) {
                const blob = new Blob([JSON.stringify(inventario)], { type: 'application/json' });
                const storage = firebase.storage();
                // Save inventario to Cloud Storage
                // Create a storage reference from our storage service
                const storageRef = storage.ref('inventarios');
                const inventarioRef = storageRef.child(`${id}.json`);
                // Upload the file
                return inventarioRef.put(blob)
                    .then(() => {
                        // Get the download URL
                        return inventarioRef.getDownloadURL();
                    });
            },
            getLatestInventories() {
                if (!this.almacen) return;
                this.db
                    .collection("inventarios")
                    .where('almacen.iclocid', '==', this.almacen.iclocid)
                    .orderBy("created_at", "desc")
                    .limit(3)
                    .get()
                    .then((querySnapshot) => {
                        querySnapshot.forEach((doc) => {
                            let data = doc.data();
                            localStorage.setItem(`inventario-${doc.id}`, JSON.stringify(data));
                            this.latest_inventories.push({ id: doc.id, 'data': data });
                        });
                    });
            },

            inventory() {
                this.loading = true;
                this.loading_status = "Realizando inventario...";
                let cartons = JSON.parse(JSON.stringify(this.cartons));
                this.$forceUpdate();
                //let time_delta = new Date(now.getTime() - this.inventario.periodo * 24 * 60 * 60 * 1000), now = new Date();;
                for (let id in cartons) {
                    cartons[id].scanned = true;
                }
                this.db.collection("cartons")
                    .where("iclocid", "==", this.almacen.iclocid)
                    .where("status_code", "==", "en-almacen")
                    
                    .get()
                    .then((querySnapshot) => {

                        // if (querySnapshot.empty) {
                        //     M.toast({ html: " <i class='mdi mdi-alert-circle'></i>&nbsp;No hay cartones en el almacén", classes: "orange" });
                        //     return
                        // }
                        querySnapshot.forEach((doc) => {
                            let doc_data = doc.data();
                            this.cartons_en_almacen[doc.id] = doc_data;
                            if (doc.id in cartons) {
                                this.cartons_scanned_db[doc.id] = {scanned:true, ...doc_data};
                            }
                            else {
                                this.cartons_scanned_db[doc.id] = {scanned:false, ...doc_data};
                            }
                        });
                        let cartons_no_db = new Set(Object.keys(cartons)).difference(new Set(Object.keys(this.cartons_scanned_db)))
                        console.log("No DB", cartons_no_db)
                        // Obtengo los cartones que no estan en la base de datos, es decir que se escaneo y no se consulto a la base de datos.
                        this.loading_steep++;
                        this.loading_status = "Obteniendo documentos externos."
                        this.$forceUpdate();
                        cartons_no_db.forEach(async id => {
                            console.log("Fetching", id)
                            let doc = await this.db.collection("cartons").doc(id).get()
                            let doc_data = doc.data()
                            if (doc_data) this.cartons_scanned_db[id] = { scanned:true, ...doc_data}

                        })
                        this.loading_steep++;
                        this.saveInventoryToFirestore();

                    }).catch((error) => {
                        console.log("Error getting documents: ", error);
                        this.loading = false;
                        this.loading_status = "";
                        this.error = error;
                        this.$forceUpdate();
                    });
            },
            getJobsFromCartons(cartons) {
                let ccmasterids = {}
                Object.values(cartons).forEach((carton) => {
                    if (ccmasterids[carton.ccmasterid]) {
                        ccmasterids[carton.ccmasterid].push(carton)
                    } else {
                        ccmasterids[carton.ccmasterid] = [carton]
                    }
                })
                return Object.keys(ccmasterids);
            },

          


        },
        computed: {
            LoadingStatus() {
                return this.loading_steep + "/" + this.total_steeps + " " + this.loading_status
            },
            LoadingPercent() {
                return Math.round((this.loading_steep / this.total_steeps) * 100) + "%";
            },
            AllJobs() {
                let missing = this.MissingCartons,
                    jobs = this.Jobs;
                // TODO: mix the entries missing and jobs
                let allJobs = Object.assign({}, jobs);
                for (let key in missing) {
                    if (!allJobs[key]) allJobs[key] = {};
                    Object.assign(allJobs[key], missing[key]);
                }
                return allJobs;

            },
            TotalOfJobs() {
                return Object.keys(this.Jobs).length
            },
            Jobs() {
                // Agrupa los cartones escaneados por ccmasterid para poder mostrarlos en el collapsible
                // cada carton tiene un ccmasterid y cada ccmasterid puede tener varios cartones
                // esto nos permite mostrar todos los cartones que tienen el mismo ccmasterid en un solo item del collapsible
                let ccmasterids = {}
                Object.entries(this.cartons_scanned_db).forEach(([key, carton]) => {

                    carton.id = key
                    if (ccmasterids[carton.ccmasterid]) {
                        ccmasterids[carton.ccmasterid][key] = carton
                    } else {
                        ccmasterids[carton.ccmasterid] = { [key]: carton }
                    }
                })
                return ccmasterids
            },
            // Retorna el total de cartones escaneados
            CartonsCount() { return Object.keys(this.cartons).length },
            /**
             * Una funcion que retorna los cartones faltantes en almacen
             * segun la base de datos.
             * @param {Object} cartons
             * @return {Object} Los cartones faltantes estan agrupados por ccmasterid
             */
            MissingCartons() {
                let missingCartons = {}
                if (Object.keys(this.cartons_en_almacen).length == 0) return {}
                let en_almacen = new Set(Object.keys(this.cartons_en_almacen))
                let cartons = new Set(Object.keys(this.cartons_scanned_db))
                en_almacen.difference(cartons).forEach((cartonId) => {
                    let carton = this.cartons_en_almacen[cartonId]
                    carton.id = cartonId
                    if (missingCartons[carton.ccmasterid]) {
                        missingCartons[carton.ccmasterid][cartonId] = carton
                    } else {
                        missingCartons[carton.ccmasterid] = { [cartonId]: carton }
                    }
                })
                return missingCartons
            },
            CartonesSobrantes() {
                let missingCartons = {}
                if (Object.keys(this.cartons_en_almacen).length == 0) return {}
                let en_almacen = new Set(Object.keys(this.cartons_en_almacen))
                let cartons = new Set(Object.keys(this.cartons))
                cartons.difference(en_almacen).forEach((cartonId) => {
                    let carton = this.cartons[cartonId]
                    carton.id = cartonId
                    if (missingCartons[carton.ccmasterid]) {
                        missingCartons[carton.ccmasterid][cartonId] = carton
                    } else {
                        missingCartons[carton.ccmasterid] = { [cartonId]: carton }
                    }
                })
                return missingCartons
            },

            MissingCartonsCountCartons() {

                if (Object.keys(this.cartons_en_almacen).length == 0) return 0
                let en_almacen = new Set(Object.keys(this.cartons_en_almacen))
                let cartons = new Set(Object.keys(this.cartons_scanned_db))
                return [...en_almacen.difference(cartons)].length
            },
            Allcmasterid() {
                //Mix getJobsFromCartons(this.cartons) + getJobsFromCartons(this.cartons_en_almacen)
                let ccmasterids = this.getJobsFromCartons(this.cartons_scanned_db).concat(this.getJobsFromCartons(this.cartons_en_almacen));
                ccmasterids = ccmasterids.concat(this.getJobsFromCartons(this.cartons));
                // unique ccmasterids
                ccmasterids = [...new Set(ccmasterids)];
                return ccmasterids
            },
            // AllJobsAndPayments() {
            //     let ccmasterids = this.AllJobs
            //     if (!this.payments) return
            //     Object.entries(ccmasterids).forEach(([ccmasterid, cartons]) => {
            //         console.log(ccmasterids, ccmasterid)
            //         let cartons_of_ccmasterid = cartons
            //         let total_of_payments = 0
            //         let total_of_job = 0
            //         if (this.payments[ccmasterid] && this.payments[ccmasterid].length > 0) {
            //             total_of_payments = this.payments[ccmasterid].reduce((total, payment) => total + payment.Monto * 1.0, 0)
            //             total_of_job = this.payments[ccmasterid].reduce((max_total, payment) => Math.max(max_total, payment.Total * 1.0), -1)
            //         }
            //         ccmasterids[ccmasterid] = { payments_total: total_of_payments, total_amount: total_of_job, cartons: cartons_of_ccmasterid }

            //     })
            //     return ccmasterids
            // },
            // JobsWithoutPayments() {
            //     let ccmasterids = this.AllJobsAndPayments
            //     if (!ccmasterids) return
            //     let not_payments = {}
            //     Object.keys(ccmasterids).forEach((ccmasterid) => {
            //         if (ccmasterids[ccmasterid].payments_total < 1) {
            //             not_payments[ccmasterid] = ccmasterids[ccmasterid]
            //         }
            //     })
            //     return not_payments

            // },
            // JobsWithPayments() {
            //     let ccmasterids = this.AllJobsAndPayments
            //     if (!ccmasterids) return
            //     let with_payments = {}
            //     Object.keys(ccmasterids).forEach((ccmasterid) => {
            //         if (ccmasterids[ccmasterid].payments_total > 1) {
            //             with_payments[ccmasterid] = ccmasterids[ccmasterid]
            //         }
            //     })
            //     return with_payments
            // },


        },

    };
</script>